import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LanguageService } from '../service/language.service';
import { LangFlagComponent } from './lang-flag/lang-flag.component';
import { PersonaAvatarComponent } from './persona-avatar/persona-avatar.component';
import { SelectTimePickerComponent } from './select-time-picker/select-time-picker.component';
import { SelectTimeRowComponent } from './select-time-row/select-time-row.component';
import { CalendarComponent } from './calendar/calendar.component';
import { MaterialModule } from '../material.module';
import { MomentModule } from 'ngx-moment';
import { BookingTimeRowComponent } from './booking-time-row/booking-time-row.component';
import { ChipsComponent } from './chips/chips.component';
import { EventsTeacherComponent } from './events-teacher/events-teacher.component';
import { StudentEvaluationComponent } from './student-evaluation/student-evaluation.component';
import { MinimalPersonaAvatarComponent } from './minimal-persona-avatar/minimal-persona-avatar.component';
import { TranslateModule } from '@ngx-translate/core';
import { DownloadLingueoDirective } from './download-lingueo/download-lingueo.directive';
import { OutlookLingueoDirective } from './outlook-lingueo/outlook-lingueo.directive';
import { ManageExercicesMediasComponent } from './manage-exercices-medias/manage-exercices-medias.component';
import { ManageExercicesAnswersTextComponent } from './manage-exercices-answers-text/manage-exercices-answers-text.component';
import { ManageExercicesAnswersChoiceComponent } from './manage-exercices-answers-choice/manage-exercices-answers-choice.component';
import { PreventPasteDirective } from './prevent-paste.directive';

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MaterialModule,
    TranslateModule.forChild(),
    MomentModule,
  ],
  declarations: [
    LangFlagComponent,
    PersonaAvatarComponent,
    SelectTimePickerComponent,
    SelectTimeRowComponent,
    CalendarComponent,
    BookingTimeRowComponent,
    ChipsComponent,
    // check if useful
    EventsTeacherComponent,
    StudentEvaluationComponent,
    MinimalPersonaAvatarComponent,
    DownloadLingueoDirective,
    OutlookLingueoDirective,
    ManageExercicesMediasComponent,
    ManageExercicesAnswersTextComponent,
    ManageExercicesAnswersChoiceComponent,
    PreventPasteDirective
  ],
  exports: [
    LangFlagComponent,
    PersonaAvatarComponent,
    SelectTimePickerComponent,
    SelectTimeRowComponent,
    CalendarComponent,
    BookingTimeRowComponent,
    MinimalPersonaAvatarComponent,
    ChipsComponent,
    DownloadLingueoDirective,
    OutlookLingueoDirective,
    ManageExercicesMediasComponent,
    ManageExercicesAnswersTextComponent,
    ManageExercicesAnswersChoiceComponent,
    PreventPasteDirective
  ],
  providers: [LanguageService]
})
export class DirectiveModule { }
